/**
 * Directive: posNavigator
 */
angular.module('acme.common.directive.posNavigator', [
  'acme.common.service.posConfig'
])
.directive('posNavigator', [ '$timeout', 'PosConfigService', function($timeout, PosConfigService) {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/pos/navigator/navigator.tpl.html',
      scope: {
        showPagination: '@',
        showPaginationDots: '@',
        pages: '='
      },

      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.posNavigator = {

          model: [], // Not used $scope.pages is used instead
          currentPage: {},
          currentPageIndex: 0,

          init: function() {
            $scope.$on('PosNavigation::Update', function() {
              $scope.posNavigator.currentPage = PosConfigService.pages.getSelectedPage().page;
            });
          },

          isCurrent: function(page) {
            var r = false;

            if (page && this.currentPage) {
              r =  (page.id === this.currentPage.id);
            }

            return r;
          },

          select: function(page, index) {
            this.currentPageIndex = index;
            $scope.$emit('PosNavigation::Select', page);
          },

          next: function() {
            var next = ++this.currentPageIndex % $scope.pages.length;

            this.select($scope.pages[next], next);
          },

          previous: function() {
            var previous = --this.currentPageIndex % $scope.pages.length;

            if (this.currentPageIndex === -1) {
              previous = $scope.pages.length - 1;
            }
            this.select($scope.pages[previous], previous);
          }

        };

        $scope.posNavigator.init();

      }]

    };

}]);